import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { Play } from 'lucide-react';

interface VideoThumbStyle {
  backgroundImage?: string;
  [key: string]: string | undefined;
}

interface VideoProps {
  videoThumbStyle?: VideoThumbStyle;
  videoUrl?: string;
}

const Video: React.FC<VideoProps> = (props) => {
  const { videoUrl, videoThumbStyle } = props;
  const [active, setActive] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setActive(!active);
  };

  if (active) {
    return (
      <div
        className="bg-[#1b1b1b] bg-cover bg-center text-center rounded aspect-w-16 aspect-h-9 h-64 sm:h-96 md:h-128"
      >
        <ReactPlayer url={videoUrl} width="100%" height="100%" />
      </div>
    );
  }
  return (
    <div
      className="bg-[#1b1b1b] cursor-pointer bg-cover bg-center text-center rounded aspect-w-16 aspect-h-9 h-64 sm:h-96 md:h-128"
      style={videoThumbStyle}
      onClick={handleClick}
    >
      <div
        style={{
          position: 'absolute',
          top: '40%',
          left: '45%',
        }}
      >
        <Play className="w-24 h-24 cursor-pointer opacity-80 hover:opacity-100 text-danger hover:text-danger" />
      </div>
    </div>
  );
};

export default Video;
